import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Collapse,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import Groups3Icon from '@mui/icons-material/Groups3';
import licenses from '../lib/combined-attributions';

const useStyles = () => ({
  licenseBlock: {
    fontSize: '12px',
    fontWeight: 'normal',
    padding: '8px 0',
  },
  fullTextLink: {
    color: '#00658F',
    cursor: 'pointer',
  },
});

const LicenseLine = ({ license, title, propName }) => {
  return (
    license[propName] && (
      <>
        <span style={{ fontWeight: 'bold' }}>{title}:</span> {license[propName]}
        <br />
      </>
    )
  );
};

const LicenseEntry = ({ license }) => {
  const theme = useTheme();
  const style = useStyles(theme);
  const [open, setOpen] = useState(false);

  if (!license) {
    return null;
  }

  if (license) {
    return (
      <>
        <div style={style.licenseBlock}>
          <LicenseLine license={license} title="Project" propName="name" />
          <LicenseLine license={license} title="Author" propName="author" />
          <LicenseLine license={license} title="Source" propName="homepage" />
          <LicenseLine license={license} title="License Name" propName="license" />
          <span style={{ fontWeight: 'bold' }}>License Text: </span>
          <span style={style.fullTextLink} onClick={() => setOpen(state => !open)}>
            Click to see license text
          </span>
          <Collapse in={open}>{license.licenseText}</Collapse>
        </div>
      </>
    );
  }
};

const OSAttributionsModal = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <div>
          <Groups3Icon />
        </div>
        Open Source Attributions
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {licenses.map((license, index) => (
            <LicenseEntry key={index} license={license} />
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default OSAttributionsModal;
